<template>
  <el-dialog
    :title="dialogCheckout.title"
    width="500px"
    :visible.sync="dialogCheckout.isShow"
    @open='open'
    center
  >
    <el-divider style="margin:5px"></el-divider>
    <el-form @submit.native.prevent label-width="100px">      
      <!-- <el-form-item label="代金券支付" class="bottom3">
        <el-select  placeholder="请选择代金券" v-model="paidInfo.CouponPaid">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="积分支付" class="bottom3" v-if="dialogCheckout.memberLogin" >
        <el-switch
          :active-text="pointPaidDesc" 
          v-model="isPointPay">
        </el-switch>
      </el-form-item>
      <el-form-item label="奖励金支付" class="bottom3" v-if="dialogCheckout.memberLogin" >
         <el-switch 
          :active-text="rewardPaidDesc" 
          v-model="isRewardPay">
        </el-switch>
      </el-form-item>
      <el-form-item label="余额支付" class="bottom3" v-if="dialogCheckout.memberLogin" >
         <el-switch
         :active-text="valuePaidDesc" 
          v-model="isValuePay">
        </el-switch>
      </el-form-item>
      <el-divider style="margin:5px"></el-divider>
      <el-form-item label="" class="bottom3">
         还需支付{{leftPaid}}元
      </el-form-item>
      <el-divider style="margin:5px"></el-divider>
      <el-form-item label-width="0px" class="bottom3">
        <el-button type="warning" @click="setPayType(1)" plain >现金支付{{cashPaid}}元</el-button>
        <el-button type="success" @click="setPayType(2)" plain>微信/支付宝{{thirdPaid}}元</el-button>
        <el-button type="primary" @click="setPayType(3)" plain>其他支付{{otherPaid}}元</el-button>
      </el-form-item>
      <el-form-item label="付款码" class="bottom3" v-if="thirdPaid>0">
        <el-col :span="20">
          <el-input v-model="paidInfo.PayCode"></el-input>
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="附加信息">
        <el-col :span="12">
          <el-input ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="介绍人卡号">
        <el-col :span="12">
          <el-input ></el-input>
        </el-col>
      </el-form-item> -->
      <el-form-item label="密码" class="bottom3" v-if="isInputPawword">
        <el-col :span="20">
          <el-input show-password placeholder="请输入密码" v-model="paidInfo.Password"></el-input>
        </el-col>
      </el-form-item> 
       <el-form-item label="备注" class="bottom3" >
        <el-col :span="20">
          <el-input  placeholder="请输入备注" v-model="paidInfo.memo"></el-input>
        </el-col>
      </el-form-item>  
    </el-form>   
    <span slot="footer" class="dialog-footer center">
      <el-button @click="dialogCheckout.isShow = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
   export default {
    props:{
      dialogCheckout:{}
    },
    data(){
      return {
        payType:0,
        isPointPay:false,
        isValuePay:false,
        isRewardPay:false,
        paidInfo:{
          ReceivableAmount:0,
          ProductAmount:0,
          ReceiptAmount:0,
          PreferentialFee:0,
          CouponPaid:0,
          PointPaid:0,
          ValuePaid:0,
          RewardPaid:0,
          // CashPaid:0,
          // ThirdPaid:0,
          // OtherPaid:0,
          MemberCouponId:'',
          PayCode:'',
          Password:''
        }
      }
    },
    computed:{
      pointPaid: function(){
        if(this.paidInfo.ReceiptAmount ==0||this.paidInfo.ReceiptAmount==undefined||
				  this.isPointPay ==false || this.dialogCheckout.member.isNormalVip==false){
					return 0;
				}
				if(this.paidInfo.ReceiptAmount * this.dialogCheckout.member.pointPayLimit > this.dialogCheckout.member.pointValue){						
					return this.dialogCheckout.member.pointValue;
				}else{
					return this.paidInfo.ReceiptAmount * this.dialogCheckout.member.pointPayLimit;
				}
      },
      valuePaid: function(){
				if(this.paidInfo.ReceiptAmount==0||this.paidInfo.ReceiptAmount==undefined||
				  this.isValuePay ==false ){
					return 0;
				}
				if(this.paidInfo.ReceiptAmount -this.pointPaid> this.dialogCheckout.member.value){
					return this.dialogCheckout.member.value;
				}else{
					return this.paidInfo.ReceiptAmount -this.pointPaid;
				}
      },
      rewardPaid: function(){
				if(this.paidInfo.ReceiptAmount==0||this.paidInfo.ReceiptAmount==undefined||
				  this.isRewardPay ==false ){
					return 0;
				}
				if(this.paidInfo.ReceiptAmount -this.pointPaid-this.valuePaid> this.dialogCheckout.member.reward){
					return this.dialogCheckout.member.reward;
				}else{
					return this.paidInfo.ReceiptAmount -this.pointPaid-this.valuePaid;
				}
			},
      leftPaid:function(){
        let value= this.paidInfo.ReceiptAmount - this.pointPaid
        - this.valuePaid - this.rewardPaid
        return value
      },
      cashPaid:function(){
        if(this.payType==1)
          return this.leftPaid
        else 
          return 0
      },      
      thirdPaid:function(){
        if(this.payType==2)
          return this.leftPaid
        else 
          return 0
      },      
      otherPaid:function(){
        if(this.payType==3)
          return this.leftPaid
        else 
          return 0
      },
      pointPaidDesc:function(){
        return '积分支付'+ this.pointPaid +'元'
      },
      rewardPaidDesc:function(){
        return '奖励金支付'+this.rewardPaid+'元'
      },      
      valuePaidDesc:function(){
        return '余额支付'+this.valuePaid+'元'
      },
      isInputPawword:function(){
        if(this.pointPaid>0 || this.valuePaid>0 || this.rewardPaid>0 )
          return true
        else 
          return false
      }
    },
    mounted(){      
    },
    methods:{
      open:function(){
        this.paidInfo.ReceivableAmount = this.dialogCheckout.ReceivableAmount
        this.paidInfo.ProductAmount = this.dialogCheckout.ProductAmount
        this.paidInfo.ReceiptAmount = this.dialogCheckout.ReceiptAmount
        this.paidInfo.PreferentialFee = this.dialogCheckout.PreferentialFee
        this.paidInfo.CouponPaid = 0
        this.paidInfo.PointPaid = 0
        this.paidInfo.ValuePaid = 0
        this.paidInfo.RewardPaid = 0    
        this.isPointPay = false
        this.isValuePay = false
        this.isRewardPay = false
        this.paidInfo.MemberCouponId = ''
        this.paidInfo.PayCode = '',
        this.paidInfo.Password = ''
      },
      submit:function(){
        this.paidInfo.PointPaid = this.pointPaid
        this.paidInfo.ValuePaid =this.valuePaid
        this.paidInfo.RewardPaid = this.rewardPaid
        this.paidInfo.CashPaid = this.cashPaid
        this.paidInfo.ThirdPaid = this.thirdPaid
        this.paidInfo.OtherPaid = this.otherPaid
        this.$emit('UpdatedCheckout',this.paidInfo)
        this.dialogCheckout.isShow = false
      },
      setPayType(type){
        this.payType = type
      },

    }
   }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.el-button--primary
  margin-left 5px
.el-dialog--center .el-dialog__body
  padding 0 20px
.bottom3
  margin-bottom 3px
</style>
